/**
 * coalesce.ts — Gộp lời gọi dồn dập: lần đầu chạy NGAY, các lần gọi trong `windowMs` sau đó dồn thành MỘT lần chạy ở
 * cuối khung (không bỏ sót thay đổi cuối cùng). Dùng cho làm mới danh sách hội thoại theo sự kiện realtime.
 */
export function createCoalescer(fn: () => void, windowMs: number): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null
  let pending = false
  const fire = () => {
    fn()
    timer = setTimeout(() => {
      timer = null
      if (pending) {
        pending = false
        fire()
      }
    }, windowMs)
  }
  return () => {
    if (timer) pending = true
    else fire()
  }
}
